import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type ComboPreviewType } from '@/defs/combo'
import { cn } from '@/utils/commonUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'

import styles from './StatComboRequirements.module.scss'

type Props = {
  combo: ComboPreviewType
}

export const StatComboRequirements = ({ combo }: Props) => {
  const popover = (
    <>
      <h2>
        <IconWithLabel iconBefore='cards'>Requirements</IconWithLabel>
      </h2>
      <p>
        This combo requires <strong>{combo.cards.length}</strong> cards (
        {combo.cards.map((card) => card.name).join(', ')}).
        {combo.nonCardPrerequisiteCount > 0 ? (
          <span>
            {' '}
            It also requires <strong>{combo.nonCardPrerequisiteCount}</strong> other prerequisite
            <span>{combo.nonCardPrerequisiteCount > 1 ? 's' : ''}</span>
            <span>.</span>
          </span>
        ) : null}
      </p>
    </>
  )

  const prereqs = combo.nonCardPrerequisiteCount
  const hasPrereqs = prereqs > 0

  return (
    <StatCommonBox label='Required' popover={popover}>
      <span className={cn(styles.container, { hasPrereqs, styles })}>
        <span className={styles.cards}>
          <IconWithLabel iconBefore='cards' iconBeforeSize='sm'>
            {combo.cards.length}
          </IconWithLabel>
        </span>
        {hasPrereqs && (
          <span className={styles.prereqs}>
            +{prereqs} prereq
            <span>{prereqs > 1 ? 's' : ''}</span>
          </span>
        )}
      </span>
    </StatCommonBox>
  )
}
